// extracted by mini-css-extract-plugin
module.exports = {"container":"HomePage_container__3tvUr","s1":"HomePage_s1__3JI_y","s1Title":"HomePage_s1Title__1z8up","s1Subtitle":"HomePage_s1Subtitle__2DLxi","s1Link":"HomePage_s1Link__tno64"};